import { VIETCAP_VALUATION_API, VIETCAP_VALUATION_PARAMS } from '../constants'

const cache = new Map()

const normalize = points => (points || []).map(p => ({
  time: String(p.tradingDate).substring(0, 10),
  value: Number(p.value),
}))

// Uses fetch rather than the axios instances: Vietcap answers 400 (with no CORS
// header) to any request whose Referer is not a Vietcap page, and XHR cannot
// drop the Referer. fetch can (`referrerPolicy: 'no-referrer'`). It also keeps
// the user's bearer token (`$httpUser`) away from a third party. No custom
// headers keeps the request "simple", so the browser skips the CORS preflight.
export function fetchValuation(symbol) {
  const key = symbol.toUpperCase()
  if (!cache.has(key)) {
    const query = new URLSearchParams(VIETCAP_VALUATION_PARAMS).toString()
    const request = fetch(`${VIETCAP_VALUATION_API}/${key}?${query}`, { referrerPolicy: 'no-referrer' })
      .then(response => {
        if (!response.ok) throw new Error(`Vietcap valuation request failed (${response.status})`)

        return response.json()
      })
      .then(body => {
        if (!body || body.successful !== true || body.data == null) {
          throw new Error('Vietcap valuation request failed')
        }

        return {
          pe: normalize(body.data.pe),
          pb: normalize(body.data.pb),
        }
      })
      .catch(error => {
        cache.delete(key)
        throw error
      })
    cache.set(key, request)
  }

  return cache.get(key)
}
